import { render, staticRenderFns } from "./AulaCard.vue?vue&type=template&id=a9bd1350&scoped=true&"
import script from "./AulaCard.vue?vue&type=script&lang=ts&"
export * from "./AulaCard.vue?vue&type=script&lang=ts&"
import style0 from "./AulaCard.vue?vue&type=style&index=0&id=a9bd1350&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bd1350",
  null
  
)

export default component.exports